import { createSlice } from "@reduxjs/toolkit";

export const initialState: any = {
  leadData: [],
  singleLeadData: [],
  leadSuccessMsg: {
    message: "",
    id: ""
  },
  leadErrorMsg: {
    message: "",
    id: ""
  },
  loading: true,
  pagination: {},
};

const leadSlice = createSlice({
  name: "lead",
  initialState,
  reducers: {
    fetchSingleLeadData(state, action) {
      state.singleLeadData = action.payload.data;
    },
    fetchLeadData(state, action) {
      state.leadData = action.payload.data;
    },
    setPaginationCount(state, action) {
      state.paginationCount = action.payload;
    },
    setPagination(state, action) {
      state.pagination = action.payload;
    },
    leadSuccessMsg(state, action) {
      state.leadSuccessMsg.message = action.payload.message;
      state.leadSuccessMsg.id = action.payload.id;
    },
    leadErrorMsg(state, action) {
      state.leadErrorMsg = action.payload;
      state.deleteUserSuccessfull = false;
      state.editUserSuccessfull = !state.editUserSuccessfull;
    },
    setLeadLoader(state, action) {
      state.loading = action.payload;
    },
  },
});

export const {
  fetchSingleLeadData,
  fetchLeadData,
  setPagination,
  setLeadLoader,
  leadSuccessMsg,
  leadErrorMsg,
} = leadSlice.actions;

export default leadSlice.reducer;
